import React from 'react';
import {
  SegmentedRadioButton,
  SegmentedRadioButtonGroup,
} from '../../segmentedRadioButtons';

interface ToggleOption {
  value: string;
  label: string;
}

export const ToggleFilterControl = ({
  value,
  onChange,
  options,
}: {
  value: string;
  onChange: (value: string) => void;
  options: ToggleOption[];
}) => {
  return (
    <SegmentedRadioButtonGroup size="xs" value={value} onChange={onChange}>
      <>
        {options.map((option) => (
          <SegmentedRadioButton key={option.value} value={option.value}>
            {option.label}
          </SegmentedRadioButton>
        ))}
      </>
    </SegmentedRadioButtonGroup>
  );
};
